import { render, staticRenderFns } from "./ClientesDadosDevolucoes.vue?vue&type=template&id=0b42a19f&scoped=true&"
import script from "./ClientesDadosDevolucoes.vue?vue&type=script&lang=js&"
export * from "./ClientesDadosDevolucoes.vue?vue&type=script&lang=js&"
import style0 from "./ClientesDadosDevolucoes.vue?vue&type=style&index=0&id=0b42a19f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b42a19f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardActions,VCol,VContainer,VDataTable,VIcon,VRow,VTooltip})
